import { translateField } from "@cdv/jazz-i18n";
import { Box, Button, Card, CardContent, Stack, Typography } from "@mui/material";
import { ReactElement, useContext } from "react";
import AppBar from "../ui/AppBar";
import { Resource } from "../utils";
import { useNavigate } from "react-router";
import { ActionType, AppContext } from "@cdv/jazz-ui";

export default function Terms(): ReactElement {
  const sx = { fontSize: "11px", color: "#00000099", mt: "15px" };
  return (
    <>
      <AppBar title={translateField(Resource.Info, "terms")} />

      <Card sx={{ mx: "16px", mt: "0 !important", borderRadius: 0, boxShadow: "none" }}>
        <CardContent sx={{ mt: 0 }}></CardContent>
      </Card>

      <Box sx={{ mt: "10px", textAlign: "center" }}>
        <Button variant="contained" color="warning" size="large">
          OK
        </Button>
      </Box>
    </>
  );
}
